import React, { useRef, useState } from 'react';
import { IncomeExpensePageShell } from './components/IncomeExpensePageShell';
import ProjectBankAccountsTab from './components/ProjectBankAccountsTab';
import { ProjectAccountLedgerDetailHandle } from './components/ProjectAccountLedgerDetail';
import ApartmentSurplusAccountsTab from './components/ApartmentSurplusAccountsTab';
import ProjectBankAccountHistoryTab from './components/ProjectBankAccountHistoryTab';

const ExportIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
  </svg>
);

const TABS = [
  { id: 'project', label: 'Tài khoản dự án' },
  { id: 'apartment', label: 'Tài khoản căn hộ' },
  { id: 'history', label: 'Lịch sử' },
];

const BankAccountsPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState('project');
  const [ledgerDetailOpen, setLedgerDetailOpen] = useState(false);
  const ledgerDetailRef = useRef<ProjectAccountLedgerDetailHandle>(null);

  return (
    <IncomeExpensePageShell
      pageTitle="Tài khoản ngân hàng"
      pageCode="IE_BANK_ACCOUNTS"
      tabs={TABS}
      activeTab={activeTab}
      onTabChange={(tabId) => {
        setActiveTab(tabId);
        if (tabId !== 'project') setLedgerDetailOpen(false);
      }}
      actions={
        activeTab === 'project' && ledgerDetailOpen
          ? [
              {
                label: 'Xuất báo cáo',
                variant: 'success',
                icon: <ExportIcon />,
                onClick: () => ledgerDetailRef.current?.exportReport(),
              },
            ]
          : undefined
      }
    >
      {activeTab === 'project' ? (
        <ProjectBankAccountsTab
          ledgerDetailRef={ledgerDetailRef}
          onLedgerDetailOpenChange={setLedgerDetailOpen}
        />
      ) : activeTab === 'history' ? (
        <ProjectBankAccountHistoryTab />
      ) : (
        <ApartmentSurplusAccountsTab />
      )}
    </IncomeExpensePageShell>
  );
};

export default BankAccountsPage;
